import { DOT_COLORS, LOAN_REQUEST_CLASSIFICATION } from 'cpool-constants';
import { SchemaLoanRequestResolver_Get, SchemaLoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { LuShuffle } from 'react-icons/lu';
import { LeadTraitInfo } from '~/types/LeadTraits';

export const getKeyedInfo = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitInfo =>
    lead.assignment === LOAN_REQUEST_CLASSIFICATION.manual || lead.assignment === LOAN_REQUEST_CLASSIFICATION.moved
        ? {
              dot: DOT_COLORS.YELLOW,
              Icon: LuShuffle,
              text: t('LEADS.TRAIT.MANUAL_KEYED'),
          }
        : null;
